import script from "./UserTrashedModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UserTrashedModal.vue?vue&type=script&setup=true&lang=js"

import "./UserTrashedModal.vue?vue&type=style&index=0&id=7e982d38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e982d38"]])

export default __exports__